/* eslint-disable @typescript-eslint/naming-convention */
export enum TrainingProgressStatus {
  None,
  AtRisk,
  Behind,
  OnTrack,
  Ahead,
  CheckridePending,
  CheckrideComplete,
}
